var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconThank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 56.875V51.4583C44 48.5852 42.8411 45.8297 40.7782 43.798C38.7153 41.7664 35.9174 40.625 33 40.625H13.75C10.8326 40.625 8.03473 41.7664 5.97183 43.798C3.90893 45.8297 2.75 48.5852 2.75 51.4583V56.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 29.7917C29.4501 29.7917 34.375 24.9414 34.375 18.9583C34.375 12.9752 29.4501 8.125 23.375 8.125C17.2999 8.125 12.375 12.9752 12.375 18.9583C12.375 24.9414 17.2999 29.7917 23.375 29.7917Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 29.7917L52.25 35.2083L63.25 24.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconThank);
export default __webpack_public_path__ + "static/media/user-icon-thank.12c7422900438c3c438257e70423c3cb.svg";
export { ForwardRef as ReactComponent };